import './App.css';
import './i18n/Config';
import { BbidGeneratorPage } from './pages/BbidGeneratorPage';
import { DiseaseAreaMetricsPage } from './pages/DiseaseAreaMetricsPage';
import { BiobankMetricsPage } from './pages/BiobankMetricsPage';
import { LabMetricsPage } from 'pages/LabMetricsPage';
import { DiseaseAreasPage } from './pages/DiseaseAreasPage';
import { BrowserRouter as Router, Redirect, Route, Switch } from 'react-router-dom';
import { MigrationsPage } from './pages/MigrationsPage';
import { TokenizationPage } from './pages/TokenizationPage';
import { HomePage } from './pages/HomePage';
import { LoginButton } from './auth/LoginButton';
import { SignInPage } from './auth/SignInPage';
import { SignOutPage } from './auth/SignOutPage';
import useAuth from 'auth/UseAuth';
import { LicenseInfo } from '@mui/x-license-pro';
import ThemeProvider from './theme/ThemeProvider';
import { CssBaseline } from '@mui/material';
import { Sidebar } from 'layout/sidebar/Sidebar';
import { SnackbarProvider } from 'notistack';
import SnackbarUtils, { SnackbarUtilsConfigurator } from 'notifications/SnackbarUtils';
import { useEffect } from 'react';
import { appSettings } from 'AppSettings';
import { ResearchProjectManagementPage } from './pages/ResearchProjectManagementPage';
import { ResearchProjectCohortPage } from './pages/ResearchProjectCohortPage';
import { PathogenGroupPage } from 'pages/PathogenGroupPage';

export const App = () => {
  const { isAuthenticated, isLoading, user } = useAuth();

  LicenseInfo.setLicenseKey(appSettings.license.muiX);

  useEffect(() => {
    const eventSource = new EventSource(
      `${appSettings.api.endpoint}/api/v2/Notifications?username=${encodeURI(user?.name ?? '')}`,
      { withCredentials: true }
    );
    eventSource.onmessage = e => {
      const obj = JSON.parse(e.data);
      SnackbarUtils.toast(obj.Message, obj.Type.toLowerCase());
    };
    return () => {
      eventSource.close();
    };
  }, [user?.name]);

  if (isLoading) {
    return <></>;
  } else if (isAuthenticated) {
    return (
      <ThemeProvider>
        <CssBaseline />
        <Sidebar />
        <SnackbarProvider maxSnack={3} anchorOrigin={{ horizontal: 'left', vertical: 'bottom' }}>
          <SnackbarUtilsConfigurator />
          <Router>
            <Switch>
              <Route path='/' exact component={HomePage} />

              <Route path='/bbidgen' component={BbidGeneratorPage} />

              <Route path='/biobank-metrics' component={BiobankMetricsPage} />

              <Route path='/lab-metrics' component={LabMetricsPage} />

              <Route path='/disease-area-metrics' component={DiseaseAreaMetricsPage} />

              <Route path='/migrations' component={MigrationsPage} />

              <Route path='/disease-areas' component={DiseaseAreasPage} />

              <Route path='/pathogens' component={PathogenGroupPage} />

              <Route path='/tokenization' component={TokenizationPage} />

              <Route exact path='/research-project' component={ResearchProjectManagementPage} />

              <Route path='/research-project/:researchProjectId' component={ResearchProjectCohortPage} />

              <Route path='/signin'>
                {' '}
                <SignInPage action='signin' />
              </Route>

              <Route path='/signin-callback'>
                <SignInPage action='signin-callback' />
              </Route>

              <Route path='/signout'>
                <SignOutPage action='signout' />
              </Route>

              <Route path='/signout-callback'>
                <SignOutPage action='signout-callback' />
              </Route>

              <Redirect to='/' />
            </Switch>
          </Router>
        </SnackbarProvider>
      </ThemeProvider>
    );
  } else {
    return (
      <div style={{ margin: 30 }}>
        Login: <LoginButton />
      </div>
    );
  }
};
